import { stdObject } from "../../../data/types/stdObject";
import { arrayToArrayObject } from "../../../utils/arrayToArrayObject";
import { arrayToObject } from "../../../utils/arrayToObject";
import { tablesInfo } from "../data/tablesInfo";

export const reorderItem = (
  itemCode: string,
  itemData: stdObject,
  extraData: stdObject,
) => {
  tablesInfo.forEach((o) => {
    const { id, key, value, filter, erase, subKey = "", code } = o;
    let data =
      id === "COMMART"
        ? false
        : extraData[code].filter((v: any) => v[filter] === itemCode);

    itemData[id] =
      id === "COMMART"
        ? extraData[code].filter((v: stdObject) => {
            return (
              (v.TIPCOZ === 1 && v.ARTCOZ === itemData.FAMART) ||
              (v.TIPCOZ === 0 && v.ARTCOZ === itemCode)
            );
          })
        : id === "FORART"
          ? itemData.TIPART === 1
            ? data.length === 0
              ? 0
              : data[0].CODFO0
            : null
          : ["PREART", "OFEART"].includes(id)
            ? arrayToArrayObject({ key, subKey, erase, data })
            : arrayToObject({
                key,
                value,
                erase,
                data,
              });
  });
  return itemData;
};
